module.exports = __webpack_public_path__ + "img/13.d22b2d0f.png";